// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"563":"d4600ac4b3a4f84e","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","7282":"458153f1179bd02f","7879":"8cc7648a5dffa864","8199":"a278752707f705af"}[chunkId] + ".css";
};